import { css, jsx } from '@emotion/core';
import React, { useEffect, useMemo, useState } from 'react';

import request from '@/utils/axios';

import DivisionTable from './DivisionTable';

const DivisionSort = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async type => {
    const result = await request({
      url: `profile/staffprofiles?type=${type}`,
    });
    const {
      data: { Profiles },
    } = result;
    setData(Profiles);
    setLoading(false);
  };

  useEffect(() => {
    fetchData('division');
  }, []);

  const divisionResults = useMemo(() => {
    let _divisionResults = {};
    const sortedData = data.sort((a, b) => (a.Division > b.Division ? 1 : -1));
    sortedData.forEach(d => {
      const division = d.Division;
      if (_divisionResults[division]) {
        _divisionResults[division].push(d);
      } else {
        _divisionResults[division] = [d];
      }
    });

    return _divisionResults
  }, [data.length]);

  return (
    <div>
      {Object.entries(divisionResults).map(result => (
        <DivisionTable key={result[0]} loading={loading} header={result[0]} staff={result[1]} />
      ))}
    </div>
  );
};

DivisionSort.propTypes = {};

export default DivisionSort;
